import type { RouteObject } from "react-router";

import { ErrorPage } from "@/components/Error/ErrorPage";
import { canAccessRegularSurveys } from "@/components/ProjectSidebar/permissions";
import { canListAnySurvey } from "@/helpers/permissions";
import { canManageSurvey } from "@/modules/surveys/permissions";

import { RequireAuth } from "../../components/Routing/RequireAuth";
import { CreateSurveyPage } from "./pages/create-or-edit/CreateSurveyPage";
import { EditSurveyPage } from "./pages/create-or-edit/EditSurveyPage";
import { SurveyDetailPage } from "./pages/details/SurveyDetailPage";
import { FeelingAtHomeDetailsPage } from "./pages/feeling-at-home-details/FeelingAtHomeDetailsPage";
import { SurveysListPage } from "./pages/list/SurveysListPage";
import { SurveyRespondPage } from "./pages/respond/SurveyRespondPage";
import { surveyRoutes } from "./routes";

export const surveysRoute = [
  {
    path: surveyRoutes.list,
    element: (
      <RequireAuth permission={canAccessRegularSurveys}>
        <SurveysListPage />
      </RequireAuth>
    ),
  },
  {
    path: surveyRoutes.new,
    element: (
      <RequireAuth permission={canManageSurvey}>
        <CreateSurveyPage />
      </RequireAuth>
    ),
  },
  {
    path: surveyRoutes.edit,
    element: (
      <RequireAuth permission={canManageSurvey}>
        <EditSurveyPage />
      </RequireAuth>
    ),
  },
  {
    path: surveyRoutes.details,
    element: (
      <RequireAuth permission={canListAnySurvey}>
        <SurveyDetailPage />
      </RequireAuth>
    ),
  },
  {
    path: surveyRoutes.respond,
    element: <SurveyRespondPage />,
  },
  {
    path: surveyRoutes.fah,
    element: (
      <RequireAuth permission={canListAnySurvey}>
        <FeelingAtHomeDetailsPage />
      </RequireAuth>
    ),
  },
  { path: "*", element: <ErrorPage status={404} /> },
] satisfies RouteObject[];
